import {OtsUIState} from "../../ots-ui-store";

export const selectTicketComparePageCriteria = (state: OtsUIState) => state.uiTicketComparePage.criteria
